import { render, staticRenderFns } from "./ReportBoxDetails.vue?vue&type=template&id=7fafd29e&"
import script from "./ReportBoxDetails.vue?vue&type=script&lang=js&"
export * from "./ReportBoxDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fafd29e')) {
      api.createRecord('7fafd29e', component.options)
    } else {
      api.reload('7fafd29e', component.options)
    }
    module.hot.accept("./ReportBoxDetails.vue?vue&type=template&id=7fafd29e&", function () {
      api.rerender('7fafd29e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportBoxDetails.vue"
export default component.exports